import { gql } from '@apollo/client'

export const CREATE_PDF_DOCUMENT_TEMPLATE = gql`
  mutation CreatePdfDocumentTemplate(
    $name: String!
    $description: String
    $pdfFile: Upload
    $signerRoles: String
    $language: String
  ) {
    pdfTemplateCreate(
      name: $name
      description: $description
      pdfFile: $pdfFile
      signerRoles: $signerRoles
      language: $language
    ) {
      ok
      templateId
      errors {
        field
        message
      }
    }
  }
`

export const CREATE_PDF_DOCUMENT_TEMPLATE_STR = `
  mutation CreatePdfDocumentTemplate(
    $name: String!
    $description: String
    $pdfFile: Upload
    $signerRoles: String
    $language: String
  ) {
    pdfTemplateCreate(
      name: $name
      description: $description
      pdfFile: $pdfFile
      signerRoles: $signerRoles
      language: $language
    ) {
      ok
      templateId
      errors {
        field
        message
      }
    }
  }
`

export const UPDATE_PDF_DOCUMENT_TEMPLATE = gql`
  mutation UpdatePdfDocumentTemplate(
    $id: ID!
    $name: String
    $description: String
    $pdfFile: Upload
    $fieldDefinitions: String
    $signerRoles: String
    $status: String
  ) {
    pdfTemplateUpdate(
      id: $id
      name: $name
      description: $description
      pdfFile: $pdfFile
      fieldDefinitions: $fieldDefinitions
      signerRoles: $signerRoles
      status: $status
    ) {
      ok
      template {
        id
        name
        status
        pdfFileUrl
        fieldDefinitions
        signerRoles
      }
      errors {
        field
        message
      }
    }
  }
`

export const UPDATE_PDF_DOCUMENT_TEMPLATE_STR = `
  mutation UpdatePdfDocumentTemplate(
    $id: ID!
    $pdfFile: Upload
    $fieldDefinitions: String
    $signerRoles: String
    $status: String
  ) {
    pdfTemplateUpdate(
      id: $id
      pdfFile: $pdfFile
      fieldDefinitions: $fieldDefinitions
      signerRoles: $signerRoles
      status: $status
    ) {
      ok
      template {
        id
        pdfFileUrl
        fieldDefinitions
        signerRoles
      }
      errors {
        field
        message
      }
    }
  }
`

export const DELETE_PDF_DOCUMENT_TEMPLATE = gql`
  mutation DeletePdfDocumentTemplate($id: ID!) {
    pdfTemplateDelete(id: $id) {
      ok
      errors {
        field
        message
      }
    }
  }
`

export const CREATE_PDF_ENVELOPE = gql`
  mutation CreatePdfEnvelope(
    $templateId: ID!
    $title: String!
    $signingOrder: String
    $sourceType: String
    $sourceId: String
    $agentId: String
    $signers: [SignerInput]!
    $sendEmail: Boolean
    $sendSms: Boolean
    $getSigningLink: Boolean
    $fieldValues: String
  ) {
    pdfEnvelopeCreate(
      templateId: $templateId
      title: $title
      signingOrder: $signingOrder
      sourceType: $sourceType
      sourceId: $sourceId
      agentId: $agentId
      signers: $signers
      sendEmail: $sendEmail
      sendSms: $sendSms
      getSigningLink: $getSigningLink
      fieldValues: $fieldValues
    ) {
      ok
      envelopeId
      emailSent
      errorMessage
      signingLinks {
        role
        token
        link
      }
    }
  }
`

export const MARK_PDF_ENVELOPE_SIGNER_AS_VIEWED = gql`
  mutation MarkPdfEnvelopeSignerAsViewed($token: String!) {
    pdfEnvelopeSignerViewed(token: $token) {
      ok
    }
  }
`

export const SUBMIT_PDF_ENVELOPE_SIGNER = gql`
  mutation SubmitPdfEnvelopeSigner(
    $token: String!
    $fieldsData: String!
    $signatureData: String!
  ) {
    pdfEnvelopeSignerSubmit(
      token: $token
      fieldsData: $fieldsData
      signatureData: $signatureData
    ) {
      ok
      errorMessage
    }
  }
`

export const RESEND_PDF_ENVELOPE_SIGNER = gql`
  mutation ResendPdfEnvelopeSigner(
    $signerId: ID!
    $sendEmail: Boolean
    $sendSms: Boolean
    $getSigningLink: Boolean
    $recipientName: String
    $recipientEmail: String
    $recipientPhone: String
  ) {
    pdfEnvelopeSignerResend(
      signerId: $signerId
      sendEmail: $sendEmail
      sendSms: $sendSms
      getSigningLink: $getSigningLink
      recipientName: $recipientName
      recipientEmail: $recipientEmail
      recipientPhone: $recipientPhone
    ) {
      ok
      signingUrl
      emailSent
      errorMessage
    }
  }
`

export const VOID_PDF_ENVELOPE = gql`
  mutation VoidPdfEnvelope($envelopeId: ID!) {
    pdfEnvelopeVoid(envelopeId: $envelopeId) {
      ok
      errorMessage
    }
  }
`
